import { useEffect, useState } from "react";

import { TOURNAMENT_MUTATED_EVENT } from "./api";

// Contador que sube con cada cambio exitoso del torneo (ver
// TOURNAMENT_MUTATED_EVENT en api.ts). Se pone en las dependencias de un
// efecto que carga el readiness para que el aviso «No puedes avanzar…» y los
// pasos bloqueados se actualicen sin recargar la página.
export function useTournamentMutationTick(tournamentId: number): number {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (Number.isNaN(tournamentId)) return;
    const onMutated = (event: Event) => {
      const detail = (event as CustomEvent<{ tournamentId?: number }>).detail;
      if (detail?.tournamentId === tournamentId) setTick((value) => value + 1);
    };
    window.addEventListener(TOURNAMENT_MUTATED_EVENT, onMutated);
    return () => window.removeEventListener(TOURNAMENT_MUTATED_EVENT, onMutated);
  }, [tournamentId]);
  return tick;
}
